import {useState} from "react";

const usePagination = () => {
  const [page, setPage] = useState({currentPage: 1, totalPages: 1});

  const onPaginate = () => {
    setPage(prev => {
      if (prev.currentPage === prev.totalPages) return prev;
      if (prev.currentPage > prev.totalPages) return {...prev, currentPage: prev.totalPages};

      return {...prev, currentPage: prev.currentPage + 1};
    });
  };

  const changePage = resp => {
    let respData;
    if (resp?.meta?.requestStatus === "fulfilled") {
      respData = resp.payload;
    }
    if (resp?.data || resp?.totalRecords || (resp?.currentPage && resp?.totalPages)) {
      respData = resp;
    }
    if (!respData) return;

    const {currentPage, totalPages} = respData;
    setPage({currentPage: currentPage || 1, totalPages: totalPages || 1});
  };

  const pageReset = () => setPage({currentPage: 1, totalPages: 1});

  return {page, setPage, onPaginate, changePage, pageReset};
};

export default usePagination;
